import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { translationChunksConfig } from '@spartacus/assets';
import {
  AuthGuard,
  CmsConfig,
  ConfigModule,
  I18nModule,
} from '@spartacus/core';
import { OutletPosition, provideOutlet } from '@spartacus/storefront';
import { SlickCarouselModule } from 'ngx-slick-carousel';
import { FluDashboardBannerModule } from '../shared/modules/flu-dashboard-banner/flu-dashboard-banner.module';
import { OverviewBannerModule } from '../shared/modules/overview-banner/overview-banner.module';
import { QuickOrderModule } from '../shared/modules/quick-order/quick-order.module';
import { CustomPipesModule } from '../shared/pipes/custom-pipes.module';
import { StatementsModule } from '../statements/statements.module';
import { AccOverviewPlaceholder1Component } from './account-overview/acc-overview-placeholder1/acc-overview-placeholder1.component';
import { AccountOverviewComponent } from './account-overview/account-overview.component';
import { FinancialsListComponent } from './account-overview/financials-list/financials-list.component';
import { NewsUpdatesComponent } from './account-overview/news-updates/news-updates.component';
import { OrderListComponent } from './account-overview/order-list/order-list.component';
import { OrderProductsComponent } from './account-overview/order-products/order-products.component';
import { CheckChildrenDirective } from "../custom-make-a-payment/directives/check-children.directive";
import { NoItemsDisclaimerComponent } from "../custom-make-a-payment/no-items-disclaimer/no-items-disclaimer.component";
import { ReactiveFormsModule } from "@angular/forms";
import { SelectGroupDirective } from "../custom-make-a-payment/directives/select-group.directive";
import { InvoicesListComponent } from "../custom-make-a-payment/invoices-list/invoices-list.component";
import { CreditsListComponent } from "../custom-make-a-payment/credits-list/credits-list.component";
import { OrdersTableComponent } from "../order-history/orders-table/orders-table.component";
import { LoaderComponent } from "./account-overview/loader/loader.component";
import { GoToMakePaymentPageButtonComponent } from "./account-overview/go-to-make-payment-page-button/go-to-make-payment-page-button.component";

@NgModule({
  declarations: [
    AccountOverviewComponent,
    OrderListComponent,
    FinancialsListComponent,
    NewsUpdatesComponent,
    OrderProductsComponent,
    AccOverviewPlaceholder1Component,
  ],
  imports: [
    CommonModule,
    I18nModule,
    LoaderComponent,
    OverviewBannerModule,
    FluDashboardBannerModule,
    RouterModule,
    SlickCarouselModule,
    StatementsModule,
    QuickOrderModule,
    NgbModule,
    CustomPipesModule,
    ConfigModule.withConfig({
      cmsComponents: {
        AccountOverviewFinancialsComponent: {
          component: () =>
            import('./account-overview/account-overview.component').then(
              (m) => m.AccountOverviewComponent
            ),
          guards: [AuthGuard],
        },
      },
      i18n: {
        backend: { loadPath: 'i18n-assets/{{lng}}/{{ns}}.json' },
      },
      chunks: translationChunksConfig,
    } as CmsConfig),
    CheckChildrenDirective,
    NoItemsDisclaimerComponent,
    ReactiveFormsModule,
    SelectGroupDirective,
    InvoicesListComponent,
    CreditsListComponent,
    OrdersTableComponent,
    GoToMakePaymentPageButtonComponent,
  ],
  providers: [
    provideOutlet({
      id: 'AccountOverviewPlaceholderSlot2',
      position: OutletPosition.REPLACE,
      component: AccOverviewPlaceholder1Component,
    }),
    provideOutlet({
      id: 'AccountOverviewOrdersSlot',
      position: OutletPosition.REPLACE,
      component: AccountOverviewComponent,
    }),
    provideOutlet({
      id: 'AccountOverviewFinancialsSlot',
      position: OutletPosition.REPLACE,
      component: FinancialsListComponent,
    }),
  ]
})
export class AccountOverviewModule {}
